import { Component, computed, inject, input } from '@angular/core';

import { UiLibraryModule } from '@template-ui/template-ui.module';
import { TabConfig } from '@template-ui/types';

import { ConfigureDlogComponent } from './configure-dlog.component';
import { PropertiesGridComponent } from '../properties-grid/properties-grid.component';
import { AppBaseComponent } from "../app-base.component";

@Component({
  selector: 'app-dev-info-tabs',
  imports: [UiLibraryModule],
  templateUrl: './dev-info-tabs.component.html',
  styleUrl: './dev-info-tabs.component.scss',
})
export class DevInfoTabsComponent extends AppBaseComponent {
  readonly SomeObject = input<object | undefined>(undefined);
  readonly useTable = input<boolean>(true);
  readonly labelColWidth = input<string>('30%');

  protected readonly tabs = computed<TabConfig[]>(() => [
    {
      label: 'DLog',
      fragment: 'dlog',
      component: ConfigureDlogComponent,
      hidden: computed(() => {return !(this.roles.isDeveloper() || this.bitsState.devModeSignal())}),
    },
    {
      label: 'Application Properties',
      fragment: 'properties',
      component: PropertiesGridComponent,
      inputs: {
        SomeObject: this.SomeObject(),
        useTable: this.useTable(),
        labelColWidth: this.labelColWidth(),
      },
    }
  ]);
}
